import React from 'react';
import styles from './ExpandButton.css';

const ExpandButton = ({ className, isExpand, ...props }) => (
  <a
    className={`${styles.expandBtn} ${isExpand ? styles.isExpand : ''} ${className}`}
    {...props}
  />
);

export default ExpandButton;



// WEBPACK FOOTER //
// ./src/components/ExpandButton/index.js